import { jsx as s, jsxs as c } from "react/jsx-runtime";
import * as l from "react";
import { c as y } from "../clsx-OuTLNxxd.js";
import "../Stats.css?__remix_sideEffect__";const m = "320px",d = "600px",f = "1025px",g = "_isVisuallyHidden_j1eef_52",h = "_stats_j1eef_64",r = "_statsItem_j1eef_73",H = "_statsItemTitle_j1eef_92",S = "_statsItemValue_j1eef_105",e = {
    mobile: m,
    "mobile-wide": "480px",
    tablet: d,
    "tablet-wide": "800px",
    desktop: f,
    "desktop-mid": "1281px",
    "desktop-large": "1360px",
    "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
    "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
    "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
    "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
    "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
    "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
    "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
    "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
    "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
    "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
    "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
    "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
    "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
    "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
    "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
    isVisuallyHidden: g,
    stats: h,
    statsItem: r,
    statsItemTitle: H,
    statsItemValue: S
  },b = l.forwardRef(({ className: t, ...x }, i) => /* @__PURE__ */s("div", { ref: i, className: y(e.stats, t), ...x })),p = l.forwardRef(({ "aria-label": t, className: x, title: i, value: n, ...o }, a) => /* @__PURE__ */c(
    "div",
    {
      className: e.statsItem,
      ref: a,
      ...o,
      "aria-label": t,
      "data-testid": "stats-item",
      children: [
      /* @__PURE__ */s("p", { className: e.statsItemValue, "aria-hidden": !!t, children: n }),
      /* @__PURE__ */s("p", { className: e.statsItemTitle, "aria-hidden": !!t, children: i })]

    }
  ));
b.displayName = "Stats";
p.displayName = "StatsItem";
export {
  b as Stats,
  p as StatsItem };